"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unify = unify;
exports.unifyAll = unifyAll;
exports.intersect = intersect;
exports.intersectAll = intersectAll;
exports.negate = negate;
exports.subtract = subtract;
exports.timeRangesOfIntersection = timeRangesOfIntersection;
exports.addBufferTime = addBufferTime;
exports.getBufferTimeRanges = getBufferTimeRanges;
exports.roundTimeUp = roundTimeUp;
exports.getFlexibleIntervalStartTimes = getFlexibleIntervalStartTimes;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutable = require("immutable");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _dates = require("MeetingsBase/constants/dates");

function unify(listTimeRanges) {
  return listTimeRanges.sort(function (x, y) {
    return x.start - y.start;
  }).reduce(function (xs, x) {
    return xs.butLast().concat(xs.size && xs.last().union(x) || [x]);
  }, (0, _immutable.List)());
}

function unifyAll() {
  for (var _len = arguments.length, arrTimeRanges = new Array(_len), _key = 0; _key < _len; _key++) {
    arrTimeRanges[_key] = arguments[_key];
  }

  return unify((0, _immutable.List)(arrTimeRanges).flatten(true));
}

function intersect(listTimeRangesA, listTimeRangeB) {
  return listTimeRangesA.map(function (timeRangeA) {
    return listTimeRangeB.map(function (timeRangeB) {
      return timeRangeB.intersect(timeRangeA);
    }).filter(function (x) {
      return x !== null;
    });
  }).flatten(true);
}

function intersectAll(listTimeRangesA, listTimeRangesB) {
  if (!listTimeRangesA) {
    return (0, _immutable.List)();
  }

  if (listTimeRangesA && !listTimeRangesB) {
    return unify(listTimeRangesA);
  }

  var intersection = intersect(listTimeRangesA, listTimeRangesB);

  for (var _len2 = arguments.length, restArr = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    restArr[_key2 - 2] = arguments[_key2];
  }

  if (restArr.length === 0) {
    return intersection;
  }

  return intersectAll.apply(void 0, [intersection, restArr[0]].concat((0, _toConsumableArray2.default)(restArr.slice(1))));
}

function negate(listTimeRanges) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  return listTimeRanges.sort(function (x, y) {
    return x.start - y.start;
  }).reduce(function (acc, timeRange) {
    return (acc.butLast() || (0, _immutable.List)()).push(acc.last().set('end', timeRange.start)).push(acc.last().set('start', timeRange.end));
  }, (0, _immutable.List)([_TimeRange.default.from({
    start: start,
    end: end
  })])).filter(function (timeRange) {
    return timeRange.start < timeRange.end;
  });
}

function subtract(listTimeRangesA, listTimeRangesB) {
  return intersect(listTimeRangesA, negate(listTimeRangesB));
}

function timeRangesOfIntersection(timeRange, listTimeRanges) {
  /**
   * Returns the TimeRanges in listTimeRanges that intersect with timeRange
   * @param {TimeRange} timeRange - The timeRange to check intersections against
   * @param {List} listTimeRanges - A list of TimeRanges where intersections
   * can occur
   * @return {List} A List of TimeRanges filtered from listTimeRanges that
   * intersect with the timeRange specified in the first parameter
   */
  return listTimeRanges.reduce(function (acc, value) {
    return value.hasIntersection(timeRange) ? acc.push(value) : acc;
  }, (0, _immutable.List)());
}

function addBufferTime(listTimeRanges, bufferTime) {
  return listTimeRanges.map(function (timeRange) {
    return _TimeRange.default.from({
      start: timeRange.start - bufferTime,
      end: timeRange.end + bufferTime
    });
  });
}

function getBufferTimeRanges(busyTimeRange, bufferTime) {
  return (0, _immutable.List)([_TimeRange.default.from({
    start: busyTimeRange.start - bufferTime,
    end: busyTimeRange.start
  }), _TimeRange.default.from({
    start: busyTimeRange.end,
    end: busyTimeRange.end + bufferTime
  })]);
}

function getPossibleStartTimes(timeRange, interval
/* millis */
) {
  return (0, _immutable.Range)(0, Math.ceil(timeRange.duration() / interval)).map(function (i) {
    return timeRange.start + i * interval;
  });
}

function roundTimeUp(time, roundTo
/* millis */
) {
  /**
   * @param {int} time A time to round, in milliseconds
   * @param {int} roundTo The interval to which to round the nearest time up
   * @returns {int} The time, rounded up to the nearest roundTo interval
   * Example: 9:15, rounded up to the nearest 10 minute interval: 9:20
   */
  return Math.ceil(time / roundTo) * roundTo;
}

function roundStartTime(timeRange, startTimeInterval
/* millis */
) {
  var roundTo = startTimeInterval < _dates.FIFTEEN_MINUTE_MILLIS ? startTimeInterval : _dates.FIFTEEN_MINUTE_MILLIS;
  var roundedStartTime = roundTimeUp(timeRange.start, roundTo);
  return timeRange.clipStart(roundedStartTime);
}

function getStartTimesForRange(timeRange, duration) {
  var startTimeInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dates.FIFTEEN_MINUTE_MILLIS;

  /**
   * @param {TimeRange} timeRange Time range to convert to regular start times
   * @param {milliseconds} duration The meeting length in milliseconds
   * @param {milliseconds} startTimeInterval The start time interval in milliseconds
   * @returns {List(timestamp)} All timestamps, at clean 15-minute intervals
   * (:00, :15, :30, :45) at which meetings of the given duration can start
   * and will have time to run to completion
   */
  return getPossibleStartTimes(timeRange, startTimeInterval).filter(function (startTime) {
    return timeRange.end - startTime >= duration;
  });
}

function getFlexibleIntervalStartTimes(listTimeRanges, duration) {
  var startTimeInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dates.FIFTEEN_MINUTE_MILLIS;

  /**
   * @param {List(TimeRange)} listTimeRanges Time ranges to convert to start times
   * @param {milliseconds} duration The meeting length in milliseconds
   * @param {milliseconds} startTimeInterval The start time interval in milliseconds
   * @returns {List(timestamp)} All timestamps, at clean 15-minute intervals
   * (:00, :15, :30, :45) at which meetings of the given duration can start
   * and will have time to run to completion
   */
  return listTimeRanges.map(function (timeRange) {
    return roundStartTime(timeRange, startTimeInterval);
  }).filter(_identity.default).map(function (timeRange) {
    return getStartTimesForRange(timeRange, duration, startTimeInterval);
  }).flatten(true).toSet().toList();
}